/**
 * codmonNotificationPanel
 * @example
 * // 基本的な使用方法
 * <codmon-notification-panel
 *   variant="info|warning|error"
 *   panel-title="パネルタイトル"
 *   default-expanded="true|false"
 *   on-toggle="handleToggle(isExpanded)"
 * >
 *   パネルディスクリプション
 * </codmon-notification-panel>
 *
 * @example
 * // デフォルトで閉じた状態
 * <codmon-notification-panel
 *   variant="info"
 *   panel-title="お知らせ"
 * >
 *   お知らせ内容
 * </codmon-notification-panel>
 *
 * @param {string} variant パネルの種類（info, warning, error）
 * @param {string} panelTitle パネルのタイトル
 * @param {boolean=} defaultExpanded パネルの初期開閉状態（デフォルト: false）
 * @param {Function=} onToggle 開閉状態が変化した時のコールバック関数（isExpanded: booleanを受け取る）
 * @transclude パネル本文（説明文など）を挿入可能
 */
angular.module('inspinia').directive('codmonNotificationPanel', function () {
  return {
    restrict: 'E',
    transclude: true,
    scope: {
      variant: '@',
      panelTitle: '@',
      defaultExpanded: '=',
      onToggle: '&',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_notification_panel.html?${new Date().getTime()}`,
    link: function (scope) {
      // 内部状態として isExpanded を管理（defaultExpanded から初期化）
      scope.isExpanded = scope.defaultExpanded || false;

      // 初期表示時にデフォルトで開いている場合のみアニメーション無効化
      scope.isInitializing = scope.isExpanded;

      // アクセシビリティ用の一意なID生成
      scope.panelContentId = `notification-panel-content-${Math.random().toString(36).substring(2, 11)}`;

      // variantごとのクラス
      scope.variantClass = function () {
        if (scope.variant === 'info') return 'variant-info';
        if (scope.variant === 'warning') return 'variant-warning';
        if (scope.variant === 'error') return 'variant-error';
        return '';
      };

      // variantごとのアイコンクラス
      scope.iconTypeClass = function () {
        if (scope.variant === 'info') return 'notification-panel-icon-info';
        if (scope.variant === 'warning') return 'notification-panel-icon-warning';
        if (scope.variant === 'error') return 'notification-panel-icon-error';
        return '';
      };

      // variantごとのアイコン名
      scope.iconName = '';
      if (scope.variant === 'info') scope.iconName = 'info_fill';
      if (scope.variant === 'warning') scope.iconName = 'warning_fill';
      if (scope.variant === 'error') scope.iconName = 'error_fill';

      // パネルの開閉をトグル
      scope.toggleExpansion = function () {
        scope.isExpanded = !scope.isExpanded;
        // 初回クリック以降はアニメーションを有効化
        if (scope.isInitializing) {
          scope.isInitializing = false;
        }
        // 親にコールバック通知
        if (scope.onToggle) {
          scope.onToggle({ isExpanded: scope.isExpanded });
        }
      };
    },
  };
});
